/**
 * tRPC React Query client for type-safe API calls.
 * Client configuration is done in App.tsx; this exports the typed client.
 */
import type { AppRouter } from "@nucleus/api/src/trpc/router";
import { createTRPCReact } from "@trpc/react-query";

/**
 * tRPC React client
 *
 * Imports AppRouter type from the API package for full type safety.
 * The actual client configuration is done in App.tsx.
 */
export const trpc = createTRPCReact<AppRouter>();
